import { connect } from 'react-redux';
import { List } from 'immutable';
import { withRouter } from 'react-router-dom';

import {
  requestEventsPageData
} from '@xanadu/ui-shared/modules/event/actions';

import Homepage from '../../../components/homepage/Homepage';

const EMPTY_LIST = new List();

const mapDispatchToProps = {
  requestEventsPageData
};

function mapStateToProps(state) {
  return {
    applicationVisible: state.getIn(['application', 'visible']),
    product: state.getIn(['application', 'product']),
    widthSize: state.getIn(['application', 'widthSize']),
    homepageTitle: state.getIn(['application', 'homepageTitle']),
    homepageDescription: state.getIn(['application', 'homepageDescription']),
    raceCardWidgetEnabled: state.getIn(['application', 'raceCardWidgetEnabled']),
    tags: state.getIn(['navigation', 'tags'], EMPTY_LIST),
    navEventIds: state.getIn(['navigation', 'eventIds']),
    events: state.get('event'),
    precannedBetslipsData: state.getIn(['events', 'precannedBetslips', 'popular'], EMPTY_LIST),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Homepage));
